/* eslint-disable @stylistic/max-len */

const about = `### What is Trove?

Trove is an _intelligent_ diary: after you write entries within it, it can tell you about your life!

### How can I use it?

Once you create a _free_ account, you will be able to write entries -- short or long, about events, feelings, goals, ideas... anything you like!

The main focus of Trove's analysis is on \`@handles,\` \`#hashtags\` and \`names\`.
These are processed every few days to generate insights.
- Who else appears alongside _@Jane_?
- When was the first time you mentioned _#travel_?
- How many times did you mention _John Smith_ in the last month?

[Learn more](/about/explore) about how Trove thinks.

### I found a bug! What do I do?

Trove is a small one-person project, so there may be rough edges around the site. If you see something not working, or simply have feedback on an existing feature or an idea for a future one, do not hesitate to get in touch at _trove_ dot _diary_ at _gmail_ dot _com_.

### What happens to my data? Is it safe?

Your data will be stored securely as per our [privacy policy](/about/privacy).
`
export default about
